import { render, staticRenderFns } from "./PettyCashExpenseItemsTable.vue?vue&type=template&id=285864c8&"
import script from "./PettyCashExpenseItemsTable.vue?vue&type=script&lang=js&"
export * from "./PettyCashExpenseItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./PettyCashExpenseItemsTable.vue?vue&type=style&index=0&id=285864c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports